import axios from "axios";
import { baseUrl } from "../config/api-config";

export function getCaseTimeline(token, caseId) {
  return axios.get(`${baseUrl}/case/${caseId}/timeline`, {
    headers: {
      authorization: token,
    },
  });
}
